import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Wrapper from '../components/atoms/Wrapper';
import Header from '../components/molecule/Header';
import Footer from '../components/molecule/Footer';
import Headline from '../components/atoms/Headline';
import Copy from '../components/atoms/Copy';
import { Link } from 'react-router-dom';

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--distance-4xs);
`;

const PrivacyPage = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Header />
      <Wrapper>
        <StyledHeadline label={t('privacy.headline')} />
        <Copy>
          <Trans t={t} i18nKey="privacy.introduction" />
        </Copy>
        <section>
          <Headline as="h2" label={t('privacy.1.headline')} />
          <Copy>
            <Trans t={t} i18nKey="privacy.1.copy">
              Verantwortlicher gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DSGVO) ist JT
              International Germany GmbH, Im Mediapark 4e, 50670 Köln, Tel. 0221 16460 (siehe unser{' '}
              <Link to={'/impressum'}>Impressum</Link>).
            </Trans>
          </Copy>
        </section>
        <section>
          <Headline as="h2" label={t('privacy.2.headline')} />
          <Copy>
            <Trans t={t} i18nKey="privacy.2.copy" />
          </Copy>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.3.headline')} />
          </article>
          <article>
            <Headline as="h3" label={t('privacy.3.1.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.3.1.copy" />
            </Copy>
          </article>
          <article>
            <Headline as="h3" label={t('privacy.3.2.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.3.2.copy" />
            </Copy>
          </article>
          <article>
            <Headline as="h3" label={t('privacy.3.3.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.3.3.copy" />
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.4.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.4.copy" />
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.5.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.5.copy" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.5.copy_2" />
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.6.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.6.copy" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.6.copy_2" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.6.copy_3" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.6.copy_4" />
            </Copy>
          </article>
          <article>
            <Headline as="h3" label={t('privacy.6.1.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.6.1.copy" />
            </Copy>
          </article>
          <article>
            <Headline as="h3" label={t('privacy.6.2.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.6.2.copy" />
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.7.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.7.copy" />
            </Copy>
          </article>
          <article>
            <Headline as="h3" label={t('privacy.7.1.headline')} />
            <Copy as="div">
              <Trans t={t} i18nKey="privacy.7.1.copy">
                <Copy>
                  Google Analytics <br /> Soweit Sie Ihre Einwilligung erklärt haben, wird auf
                  dieser Website Google Analytics eingesetzt, ein Webanalysedienst der Google LLC.
                  Verantwortliche Stelle für Nutzer in der EU/ dem EWR und der Schweiz ist Google
                  Ireland Limited, Google Building Gordon House, 4 Barrow St, Dublin, D04 E5W5,
                  Irland („Google“). Google Analytics verwendet Cookies, die eine Analyse der
                  Benutzung unserer Webseiten durch Sie ermöglichen. Die mittels der Cookies
                  erhobenen Informationen über Ihre Benutzung dieser Website werden in der Regel an
                  einen Server von Google in den USA übertragen und dort gespeichert. Bei Google
                  Analytics 4 ist die Anonymisierung von IP-Adressen standardmäßig aktiviert.
                  Aufgrund der IP-Anonymisierung wird Ihre IP-Adresse von Google innerhalb von
                  Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des
                  Abkommens über den Europäischen Wirtschaftsraum gekürzt. Nur in Ausnahmefällen
                  wird die volle IP-Adresse an einen Server von Google in den USA übertragen und
                  dort gekürzt. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte
                  IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Während Ihres
                  Website-Besuchs wird Ihr Nutzerverhalten in Form von „Ereignissen“ erfasst.
                  Ereignisse können sein:
                </Copy>
                <ul>
                  <li>Seitenaufrufe</li>
                  <li>Erstmaliger Besuch der Website</li>
                  <li>Start der Sitzung</li>
                  <li>Ihr „Klickpfad“, Interaktion mit der Website</li>
                  <li>Scrolls (immer wenn ein Nutzer bis zum Seitenende (90%) scrollt)</li>
                  <li>Klicks auf externe Links</li>
                  <li>interne Suchanfragen</li>
                  <li>Interaktion mit Videos</li>
                  <li>gesehene / angeklickte Anzeigen</li>
                </ul>
                <Copy>Außerdem wird erfasst:</Copy>
                <ul>
                  <li>Ihr ungefährer Standort (Region)</li>
                  <li>Ihre IP-Adresse (in gekürzter Form)</li>
                  <li>
                    technische Informationen zu Ihrem Browser und den von Ihnen genutzten Endgeräten
                    (z.B. Spracheinstellung, Bildschirmauflösung)
                  </li>
                  <li>Ihr Internetanbieter</li>
                  <li>
                    die Referrer-URL (über welche Website/ über welches Werbemittel Sie auf diese
                    Website gekommen sind)
                  </li>
                </ul>
              </Trans>
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_2" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_3" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_4" />
            </Copy>
            <Copy as="div">
              <Trans t={t} i18nKey="privacy.7.1.copy_5">
                Während Ihres Website-Besuchs werden u.a. folgende Daten erfasst:
                <ul>
                  <li>
                    die von Ihnen aufgerufenen Seiten, Ihr „Klickpfad“'l,0-Anmeldungen, Downloads,
                    Käufe)
                  </li>
                  <li>Ihr Nutzerverhalten (beispielsweise Klicks, Verweildauer, Absprungraten)</li>
                  <li>Ihr ungefährer Standort (Region)</li>
                  <li>
                    technische Informationen zu Ihrem Browser und den von Ihnen genutzten Endgeräten
                    (z.B. Spracheinstellung, Bildschirmauflösung)
                  </li>
                  <li>Ihr Internetanbieter</li>
                  <li>
                    die Referrer-URL (über welche Website/ über welches Werbemittel Sie auf diese
                    Website gekommen sind)
                  </li>
                </ul>
              </Trans>
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_6" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_7" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_8" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_9" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_10">
                Nähere Informationen zu Nutzungsbedingungen von Google Analytics und zum Datenschutz
                bei Google finden Sie unter
                https://marketingplatform.google.com/about/analytics/terms/de/ und unter{' '}
                <a href={'https://policies.google.com/?hl=de'} rel={'noreferrer nofollow'}>
                  https://policies.google.com/?hl=de
                </a>
                .
              </Trans>
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_11" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_12" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.7.1.copy_13">
                Alternativ können Sie die Speicherung von Cookies von vornherein durch eine
                entsprechende Einstellung Ihrer Browser-Software verhindern. Wenn Sie Ihren Browser
                so konfigurieren, dass alle Cookies abgelehnt werden, kann es jedoch zu
                Einschränkung von Funktionalitäten auf dieser und anderen Websites kommen. Sie
                können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre
                Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
                Verarbeitung dieser Daten durch Google verhindern, indem Sie
                <br /> a. Ihre Einwilligung in das Setzen des Cookies nicht erteilen oder <br /> b.
                das Browser-Add-on zur Deaktivierung von Google Analytics HIER herunterladen und
                installieren. <br /> Nähere Informationen zu Nutzungsbedingungen von Google
                Analytics und zum Datenschutz bei Google finden Sie{' '}
                <a href="https://marketingplatform.google.com/about/analytics/terms/de/">
                  hier
                </a>{' '}
                und unter{' '}
                <a href="https://policies.google.com/?hl=de">https://policies.google.com/?hl=de</a>.
              </Trans>
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.8.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.8.copy" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.8.copy_2" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.8.copy_3" />
            </Copy>
          </article>
          <article>
            <Headline as="h3" label={t('privacy.8.1.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.8.1.copy" />
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.9.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.9.copy" />
            </Copy>
          </article>
        </section>
        <section>
          <article>
            <Headline as="h2" label={t('privacy.10.headline')} />
            <Copy>
              <Trans t={t} i18nKey="privacy.10.copy" />
            </Copy>
            <Copy>
              <Trans t={t} i18nKey="privacy.status" />
            </Copy>
          </article>
        </section>
      </Wrapper>
      <Footer />
    </>
  );
};

export default PrivacyPage;
